<template>
  <div id="app">
    <router-view />
    <div v-show=show>
      <img src="../static/imgs/big-title.png">
      <img src="../static/imgs/title-h.png">
      <img src="../static/imgs/title-v.png">
      <img src="../static/imgs/data.png">
      <img src="../static/imgs/map-bg41.png">
      <img src="./assets/imgs/circle/circle-center-fill.png">
      <img src="./assets/imgs/circle/circle-center-fill2.png">
      <img src="./assets/imgs/circle/circle-center-fill3.png">
      <img src="./assets/imgs/circle/circle-center.png">
      <img src="./assets/imgs/circle/circle-outer.png">
      <img src="./assets/imgs/circle/circle-outer2.png">
      <img src="./assets/imgs/circle/circle-outer3.png">
      <img src="./assets/imgs/center-bg.jpg">
      <img src="./assets/imgs/chart-bg.png">
      <img src="./assets/imgs/box.png">
      <img src="./assets/imgs/box-details-left.png">
      <img src="./assets/imgs/box-details-right.png">
    </div>
  </div>
</template>
<script>
import { adapt } from './assets/js/common/page'
import { vueBus } from './assets/js/common/vueBus'
import Stats from './assets/js/common/stats'
export default {
  data() {
    return {
      show: false,
      count: 0
    }
  },
  mounted() {
    this.$nextTick(() => {
      let me = this
      let imgs = document.querySelectorAll('img')
      Array.from(imgs).forEach(item => {
        let img = new Image()
        img.onload = () => {
          me.count++
        }
        img.src = item.getAttribute('src')
      })
      this.page()
      let query = this.urlArgs('debug')
      let starts = this.urlArgs('stars')
      let stopTicks = this.urlArgs('stopTicks')
      if (query == 'true') {
        this.initStats()
        this.update()
      }
      if (starts == 'true') {
        canvas('stars', 230, 2000, 60, 2, 800000, 0.5)
        document.getElementById('mark').style.display = 'block'
      }
      if (stopTicks == 'true') {
        vueBus.$emit('stopTicks', 'stopTicks')
      }
    })
  },
  watch: {
    count(val, oldval) {
      if (val == 17) {
        document.getElementById('appLoading').style.display = 'none'
        vueBus.$emit('imgOnload', 'animateStart')
      }
    }
  },
  methods: {
    page() {
      adapt({
        sizeEqualRatio: true,
        w: 4583,
        h: 2500,
        domSelector: '#app'
      })
    },
    initStats() {
      this.stats = new Stats()
      this.stats.setMode(0) //0:fps |1:ms
      this.stats.domElement.style.position = 'absolute'
      this.stats.domElement.style.zIndex = '9999'
      this.stats.domElement.style.top = '0px'
      this.stats.domElement.style.right = '0px'
      document.body.appendChild(this.stats.domElement)
      return this.stats
    },
    update() {
      requestAnimationFrame(this.update.bind(this))
      this.stats.update()
    },
    urlArgs(params) {
      let args = {}
      let query = location.search.substring(1)
      let pairs = query.split('&')
      for (let i = 0; i < pairs.length; i++) {
        let pos = pairs[i].indexOf('=')
        if (pos === -1) {
          continue
        }
        let name = pairs[i].substring(0, pos)
        let value = pairs[i].substring(pos + 1)
        value = decodeURIComponent(value)
        args[name] = value
      }
      return args[params]
    }
  }
}
</script>

<style>
#app {
  position: absolute;
  box-sizing: border-box;
  background-size: cover;
  z-index: 3;
}
</style>



// WEBPACK FOOTER //
// src/App.vue